import AppContainer from '../AppContainer';
import { useCallback, useContext, useEffect, useState } from 'react';
import {
  IonInput,
  IonButton,
  IonBreadcrumb,
  IonBreadcrumbs,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonModal,
  IonSelect,
  IonSelectOption,
  IonProgressBar
} from '@ionic/react';
import { api } from '../domain/ApiService';
import useAuth from '../domain/Auth';
import React from 'react';
import Menu from '../components/Menu';
import GlobalContext from '../domain/GlobalContext';
import { Initiative, User } from '../domain/Types';
import { v4 as uuidv4 } from 'uuid';
import ListView from '../components/ListView';

const Page: React.FC = () => {

  const { isAuthenticated, isLoading } = useAuth();
  const [ key, setKey ] = useState('');
  const [ isKeyLoading, setIsKeyLoading ] = useState(false);
  const { user, initiative, users, setUsers } = useContext(GlobalContext);
  const [ isFetched, setIsFetched ] = useState(false);

  const [ showAccountModal, setShowAccountModal ] = useState(false);
  const [ selectedAccount, setSelectedAccount ] = useState<User | null>(null);
  const [ accountEmail, setAccountEmai ] = useState<string | null>(null);
  const [ accountPass, setAccountPass ] = useState<string | null>(null);
  let { initiatives, setInitiatives } = useContext(GlobalContext);
  const [ query, setQuery ] = useState('');
  const [ members, setMembers ] = useState<any[]>([]);

  let filteredInitiatives: any[] = [];
  let orderedInitiatives: any[] = [];

  const listInstanceAccounts = useCallback(async () => {
    try {
      let response = await api("/user/list", {}, initiative);
      response = response.length ? response.sort((a: any, b) => a.name.localeCompare(b.name)) : [];
      setUsers(response);
      setMembers(response);
    } catch (err) {
      console.error('Failed to fetch initiatives:', (err as Error).message);
    }
  }, []);

  const listOfInitiatives = () => {
    if (initiatives?.length) {
      let filtered = initiatives.filter(initiative => {
        return !initiative.template;
      });
      initiatives = filtered;
    }
        
  }

  const listInitiatives = useCallback(async () => {
      try {
  
        if (user != null) {
  
          const response = await api("/initiative/list", {}, initiative);
          setInitiatives(response);
          window.dispatchEvent(new Event('initiativesLoaded'));
        }
    } catch (err) {
        console.error('Failed to fetch initiatives:', (err as Error).message);
      }
    }, [user, initiative]);

  useEffect(() => {

    if (user) {
      listOfInitiatives();
      listInstanceAccounts();
    }
  }, [user]);

  const createAccount = async () => {
    if (!selectedAccount) return;
    setIsFetched(false);

    let createdAccount = (selectedAccount as any);

    if (accountEmail)
      createdAccount.email = accountEmail;

    if (accountPass)
      createdAccount["password"] = accountPass;

    const response = await api("/user/create", createdAccount, initiative) as User; 
    setSelectedAccount(null);
    setAccountPass(null);
    setAccountEmai(null);
    listInstanceAccounts(); 
    setShowAccountModal(false);
    setIsFetched(true);
  };

  const updateAccount = async () => {
    if (!selectedAccount) return;
    setIsFetched(false);
    setUsers([]);
    setShowAccountModal(false);
    let tempSelectedAccount = selectedAccount;
    if (selectedAccount.role === 'superadmin') {
      tempSelectedAccount = {
        ...tempSelectedAccount,
        initiative_ids: filteredInitiatives.map(a => a.id),
        user_id: selectedAccount.auth_id
      }
    }
    const response = await api("/user/update", tempSelectedAccount, initiative) as User;
    if (selectedAccount.role === 'superadmin') {
      listInitiatives()
    }
    listInstanceAccounts();
    if (user && selectedAccount?.auth_id === user?.auth_id) {
      user.name = selectedAccount.name; 
    }
    setIsFetched(true);
  };

  const removeAccount = async () => {
    if (!selectedAccount || (user && selectedAccount?.auth_id === user?.auth_id)) return;
    setIsFetched(false);
    const response = await api("/user/remove", selectedAccount, initiative) as User; 
    listInstanceAccounts();
    setShowAccountModal(false);
    setIsFetched(true);
  };

  const setSelectedClient = (data: any) => {
    filteredInitiatives = data;
  }

  const handleAccountEdit = (item: User | null) => {

    let editItem = item;
    if (user != null && editItem == null) {
      editItem = {  
        "uid": uuidv4(), 
        "name": "", 
        "role": "user", 
        "dark_mode": null, 
        "instance_id": user.instance_id 
      }
    }
    setSelectedAccount(editItem);
    setShowAccountModal(true);
  };
  if (initiatives != null) {
    filteredInitiatives = initiatives.filter(initiative => {
        if (selectedAccount?.auth_id && initiative && !initiative.template) {

            const isOwnerOrCollaborator = !initiative.owners || !initiative.collaborators || initiative.owners.includes(selectedAccount.auth_id) || initiative.collaborators.includes(selectedAccount.auth_id);
            const isCollaboratorOrAllUsers = !initiative.collaborators || initiative.collaborators.includes(selectedAccount.auth_id) || initiative.collaborators.length === 0 || initiative.collaborators.includes("allUsers");
            return isOwnerOrCollaborator || isCollaboratorOrAllUsers;
        }
        return false;
      });
      initiatives.forEach(a => {
        if (!filteredInitiatives.map(a => a.id).includes(a.id)) {
          orderedInitiatives.push(a);
        }
      });
      orderedInitiatives = orderedInitiatives.sort((a, b) => a.name.localeCompare(b.name));
      orderedInitiatives = initiatives.filter((item: any) => item.name);
      orderedInitiatives = [
        ...filteredInitiatives,
        ...orderedInitiatives
      ]
  }
  const handleSearchChange = (event: CustomEvent<{ value?: string | null }>) => {
    const qLower = event.detail.value?.toLowerCase();
    if (users?.length && qLower) {
      if (qLower) {
        let members = users.filter((item: any) => item.name.toLowerCase().includes(qLower));
        setMembers(members);
      }
      if (event.detail.value === '') setMembers(users);
    }
    setQuery(event.detail.value as string);
  }
  return (

    <div>

      <IonCard className='filled' style={{ padding: "10px" }}>
        <IonCardHeader>
          <IonCardTitle>Account</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <IonInput
            className='form-element'
            label="Name"
            labelPlacement="floating"
            fill="outline"
            value={user?.name}
            placeholder="Name"
          />
          <IonInput
            className='form-element'
            label="Email"
            labelPlacement="floating"
            fill="outline"
            value={user?.email}
            placeholder="Email"
            disabled
          />
          <div className='form-element'>
            <IonButton disabled>
              Update 
            </IonButton>
          </div>
          </IonCardContent>
      </IonCard>

      {user && (user.role === 'admin' || user.role === 'superadmin') && (
        <IonCard className='filled' style={{ padding: "10px" }}>
          <IonCardHeader>
            <IonCardTitle>Members</IonCardTitle>
          </IonCardHeader>
          <IonInput 
                className='form-element'
                style={{width: "98%", marginLeft: "10px"}}
                label="Search"
                labelPlacement="floating"
                fill="outline"
                placeholder="Search"
                onIonInput={handleSearchChange}
            />
          <IonCardContent>
              {users && users.length > 0 ?              
                <ListView<User>
                  items={members}
                  columns={[
                    { attribute: 'name', label: 'Name', size: "small", primary: true },
                    { attribute: 'email', label: 'Email', size: "small" },
                    { attribute: 'role', label: 'Role', size: "small" },
                  ]}
                  enableReorder={false}
                  defaultLayout="table"
                  showActions={true}
                  onEdit={handleAccountEdit}
                  />
                :
                <IonProgressBar type="indeterminate" color="medium"></IonProgressBar>
              }

          </IonCardContent>
        </IonCard>)
      }

      <IonModal className='form-modal' isOpen={showAccountModal} onDidDismiss={() => setShowAccountModal(false)}>
        <div className='form'>
          <IonSelect className='form-element' 
              label="Role" 
              labelPlacement="floating" 
              interface="popover" 
              placeholder="Role"
              defaultValue={selectedAccount?.role}
              value={selectedAccount?.role}
              onIonChange={e => setSelectedAccount(prev => {
                if (prev && e.detail.value !== null && e.detail.value !== undefined) {
                    prev.role = e.detail.value;
                }
                return prev;
              })}>
              {user && user.role === 'superadmin' && (
                <IonSelectOption key="superadmin" value="superadmin">Superadmin</IonSelectOption>)}
              <IonSelectOption key="admin" value="admin">Admin</IonSelectOption>
              <IonSelectOption key="user" value="user">User</IonSelectOption>
          </IonSelect>
          <IonInput
            className='form-element'
            label="Name"
            labelPlacement="floating"
            fill="outline"
            value={selectedAccount?.name} 
            onIonChange={e => setSelectedAccount(prev => {
              if (prev && e.detail.value !== null && e.detail.value !== undefined) {
                  prev.name = e.detail.value;
              }
              return prev;
            })} 
            placeholder="Name"
          />          
          <IonInput
            className='form-element'
            label="Email"
            labelPlacement="floating"
            fill="outline"
            value={selectedAccount?.email} 
            onIonChange={e => setSelectedAccount(prev => {
              if (prev && e.detail.value !== null && e.detail.value !== undefined) {
                  prev.email = e.detail.value;
              }
              return prev;
            })} 
            placeholder="Email"
          />
          {user && selectedAccount?.id && (user.role === 'admin' || user.role === 'superadmin') && (<IonInput
            className='form-element'
            label="Change your password"
            labelPlacement="floating"
            autocomplete="off"
            fill="outline"
            type="password"
            value={selectedAccount?.new_password} 
            onIonChange={e => setSelectedAccount(prev => {
              if (prev && e.detail.value !== null && e.detail.value !== undefined) {
                  prev.new_password = e.detail.value;
              }
              return prev;
            })} 
            placeholder="Enter new password"
          />)}
          {user && user.role === 'superadmin' && (
            <IonSelect className='form-element' 
                label="Clients"
                multiple={true} 
                labelPlacement="floating" 
                interface="popover" 
                placeholder="Clients"
                value={filteredInitiatives.map(a => a.id)}
                onIonChange={e => setSelectedClient(e.detail.value)}>
                {/* <IonSelectOption key="" value="">Select Client</IonSelectOption> */}
                {orderedInitiatives && orderedInitiatives.map(instanceUser => (
                    <IonSelectOption key={instanceUser.id} value={instanceUser.id}>
                      {instanceUser.name} {instanceUser.collaborators.includes("allUsers") ? `(All Users)` : ''}
                    </IonSelectOption>
                  ))} 
            </IonSelect>
          )}

          {!selectedAccount?.id ? <>
            <IonInput
              className='form-element'
              label="Password"
              labelPlacement="floating"
              fill="outline"
              value={accountPass} 
              onIonChange={e => setAccountPass(e.detail.value!)} 
              placeholder="Password"
            />
            <IonButton onClick={createAccount}>Create</IonButton>
          </> 
          :
            <IonButton onClick={updateAccount}>Save</IonButton>
          }

          <IonButton className='basic' onClick={() => { setShowAccountModal(false); }}>Cancel</IonButton>
          {selectedAccount?.email != user?.email && <IonButton color="danger" onClick={removeAccount}>Remove</IonButton>}
          </div>
        </IonModal> 
        
    </div>
  );
};

const Breadcrumb: React.FC = () => {
  return (
    <IonBreadcrumbs>
      <IonBreadcrumb routerLink="/account">Account</IonBreadcrumb>
    </IonBreadcrumbs>
  );
};

const MemoizedPage = React.memo(Page);
const MemoizedBreadcrumb = React.memo(Breadcrumb);

const Container: React.FC<{}> = () => { return <AppContainer ContentComponent={MemoizedPage} BreadcrumbComponent={MemoizedBreadcrumb} MenuComponent={Menu} />; };
export default Container;